import Product from "@system/config/product";
import Constants from "src/helper/Constants";
import System from "src/helper/system";
import Api from "src/service/APIHandler";

const API = new Api({});

class ProductInventoryPriceAPICall {

    getInventory = async (params) => {
        let res = {};
        let reqData = { data: params }

        await API.post(Product.PRODUCT_INVENTORY_AVNET, reqData).then((resHer) => {
            if (resHer.data) {
                res = resHer.data
            }
        });
        return res;
    }

    getPricingList = async (params = []) => {
        let res = {}
        let param = {};
        param.data = { SBOAT: System.avUserInfoData.speedBoatAbbr, SOLDTOCODE: System.avUserInfoData.currentUser === Constants.siteUser.CORE ? System.avUserInfoData.accountNumber : "", LINEITEMS: params }
        await API.post(Product.PRODUCT_PRICING_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data;
            }
        }).catch((err) => {
            res = null;
        });

        return res
    };

    getExchangeRate = async (params) => {
        let res = {};

        let param = {}
        param.data = params
        await API.post(Product.CURRENCY_CONVERSION, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data || {}
            }
        });
        return res
    }
}

export default ProductInventoryPriceAPICall;